import { useEffect, useState } from "react";
import { getShowcaseIndexByPhotoId } from "../../lib/homeHeroPhotos";
import { keywordLine, photoBackground } from "../../lib/photographyUtils";

/**
 * @param {{ onOpenLightbox: (list: import("../../hooks/useShowcasePhotos").ShowcasePhoto[], index: number) => void, initialShowcaseId?: string | null, photos?: import("../../hooks/useShowcasePhotos").ShowcasePhoto[], loading?: boolean }} props
 */
export default function ShowcaseWall({
  onOpenLightbox,
  initialShowcaseId = null,
  photos = [],
  loading = false,
}) {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!initialShowcaseId || photos.length === 0) {
      return;
    }
    const index = getShowcaseIndexByPhotoId(photos, initialShowcaseId);
    if (index >= 0) {
      setCurrent(index);
    }
  }, [initialShowcaseId, photos]);

  if (loading) {
    return (
      <section id="sub-showcase" className="photo-showcase" aria-busy="true" aria-label="Showcase" />
    );
  }

  if (photos.length === 0) {
    return (
      <section id="sub-showcase" className="photo-showcase" aria-label="Showcase">
        <div className="photo-showcase__band">
          <div className="photo-showcase__inner">
            <p className="photo-showcase__empty">Showcase photographs will appear here once added in admin.</p>
          </div>
        </div>
      </section>
    );
  }

  const photo = photos[current];

  const go = (delta) => {
    setCurrent((prev) => (prev + delta + photos.length) % photos.length);
  };

  return (
    <section id="sub-showcase" className="photo-showcase" aria-label="Showcase">
      <div className="photo-showcase__band">
        <div className="photo-showcase__inner">
          <div className="photo-showcase__frame">
            <button
              type="button"
              className="photo-showcase__mat"
              aria-label={`Open ${photo.t} in lightbox`}
              onClick={() => onOpenLightbox(photos, current)}
            >
              <div className="photo-showcase__prints" aria-hidden="true">
                {photos.map((item, index) => (
                  <div
                    key={item.id}
                    className={`photo-showcase__print${index === current ? " is-active" : ""}`}
                    style={{ background: photoBackground(item) }}
                  />
                ))}
              </div>
            </button>

            <div className="photo-showcase__controls">
              <button type="button" className="photo-showcase__nav" aria-label="Previous frame" onClick={() => go(-1)}>
                ‹
              </button>
              <div className="photo-showcase__dots">
                {photos.map((item, index) => (
                  <button
                    key={item.id}
                    type="button"
                    className={`photo-showcase__dot${index === current ? " is-active" : ""}`}
                    aria-label={`Show frame ${index + 1}: ${item.t}`}
                    onClick={() => setCurrent(index)}
                  />
                ))}
              </div>
              <button type="button" className="photo-showcase__nav" aria-label="Next frame" onClick={() => go(1)}>
                ›
              </button>
            </div>
          </div>

          <div key={photo.id} className="photo-showcase__meta">
            <div className="photo-showcase__title">{photo.t}</div>
            <div className="photo-showcase__keywords">{keywordLine(photo)}</div>
            {photo.desc ? <p className="photo-showcase__desc">{photo.desc}</p> : null}
          </div>
        </div>
      </div>
    </section>
  );
}
